module.exports = __webpack_public_path__ + "static/img/under-maintenance1.156eefa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/under-maintenance1.png
// module id = QDBi
// module chunks = 7